import { authFetch } from "lib/api/authFetch";
import { normalizeApiMessage } from "lib/i18n/apiMessage";
import { BACKEND_URL } from "lib/utils/baseUrl";

function triggerBlobDownload(blob, fileName) {
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);

  link.href = url;
  link.download = `${fileName}.hml`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

function getDownloadBaseName(value, fallback = "project-report") {
  const raw = String(value || fallback).trim();
  const extIndex = raw.lastIndexOf(".");
  return extIndex > 0 ? raw.slice(0, extIndex) : raw;
}

export async function postProjectUd1000HmlReport(
  projectId,
  fileName,
  { orderedUploadIds = [], includeCover = true } = {},
) {
  if (!projectId) {
    return {
      success: false,
      ...normalizeApiMessage(
        { message: "Invalid request. project_id is missing." },
        "Invalid request. project_id is missing.",
      ),
    };
  }

  if (!Array.isArray(orderedUploadIds) || !orderedUploadIds.length) {
    return {
      success: false,
      ...normalizeApiMessage(
        { message: "No files selected for HML export." },
        "No files selected for HML export.",
      ),
    };
  }

  try {
    const path = `${BACKEND_URL}/project/hml_project_ud1000_report/${projectId}`;
    const res = await authFetch(
      path,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ orderedUploadIds, includeCover }),
        },
      {
        refreshUrlIncludes: "auth/refresh",
      },
    );

    if (!res.ok) {
      const fallback = `Failed to download project UD1000 HML report (status: ${res.status})`;

      let parsed = null;
      try {
        parsed = await res.json();
      } catch {
        parsed = null;
      }

      const normalized = normalizeApiMessage(parsed, fallback);
      console.error("[Project UD1000 HML] request failed", {
        status: res.status,
        projectId,
        uploadCount: orderedUploadIds.length,
        uploadIdsPreview: orderedUploadIds.slice(0, 5),
        response: parsed,
      });

      return {
        success: false,
        status: res.status,
        ...normalized,
        messageKey:
          normalized.messageKey ||
          (res.status === 401 ? "api.auth.token.expired" : ""),
      };
    }

    const blob = await res.blob();
    triggerBlobDownload(blob, getDownloadBaseName(fileName, "project-report"));

    return {
      success: true,
      ...normalizeApiMessage(
        { message: "Project UD1000 HML report downloaded successfully." },
        "Project UD1000 HML report downloaded successfully.",
      ),
    };
  } catch (error) {
    console.error("Project UD1000 HML report request failed:", error);
    return {
      success: false,
      ...normalizeApiMessage(
        {
          message: error?.message || "Project UD1000 HML report request failed.",
        },
        error?.message || "Project UD1000 HML report request failed.",
      ),
      messageKey: "api.common.networkError",
    };
  }
}
